// extracted by mini-css-extract-plugin
export default {"wrap":"Vq-z","melodyCategory":"Wq-z","fullWidth":"Xq-z","items":"Yq-z","featureCss":"Zq-z","disabled":"_q-z","imgCss":"ar-z"};